import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { goToTop } from "../utils/Constant";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        goToTop();
    }, [pathname]); // Runs when route changes

    return null;
};

export default ScrollToTop;
